export default __webpack_public_path__ + "static/media/balls-details.88dad4e6.png";